var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0B90B",
    transform: "rotate(90 32 32)",
    r: 21.333,
    cy: 32,
    cx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.795 18.716a19.488 19.488 0 00-5.274 13.36 19.48 19.48 0 004.816 12.852l1.265-1.264a17.707 17.707 0 01-4.251-11.536c0-4.675 1.804-8.928 4.755-12.102l-1.31-1.31zM44.23 45.15a17.715 17.715 0 01-12.101 4.755c-4.616 0-8.82-1.76-11.98-4.643l-1.257 1.256a19.485 19.485 0 0013.184 5.112c5.166 0 9.864-2.003 13.36-5.275L44.23 45.15zm2.742-.404l-1.21-1.21a17.706 17.706 0 004.144-11.41c0-4.615-1.758-8.82-4.642-11.98l1.255-1.255a19.485 19.485 0 015.113 13.184c0 4.833-1.754 9.258-4.66 12.67zM20.719 18.494l-1.314-1.314a19.478 19.478 0 0112.671-4.66 19.48 19.48 0 0112.853 4.817L43.665 18.6a17.707 17.707 0 00-11.536-4.25 17.706 17.706 0 00-11.41 4.143z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M31.979 19.564v9.146l-7.595 3.45 7.595-12.596z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M31.979 28.71v7.943l-7.595-4.494 7.595-3.45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M31.979 38.231v6.172l-7.595-10.665 7.595 4.493z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#312706",
    d: "M31.979 19.564v9.146l7.595 3.45-7.595-12.596z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#130F03",
    d: "M31.979 28.71v7.943l7.595-4.494-7.595-3.45z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#312807",
    d: "M31.979 38.231v6.172l7.595-10.665-7.595 4.493z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps1);
export default __webpack_public_path__ + "static/media/steps_1.281d9e234c9296d410e8424ee5515509.svg";
export { ForwardRef as ReactComponent };